import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import ProductPropertyTab from '../../molecules/product-detail-accordion';
import Typography from '../../atoms/typography';

const Icon = styled.img`
  max-height: 5rem;
  max-width: 5rem;
  width: 100%;

  & ~ & {
    margin-left: 1rem;
  }
`;

const AWARD_PROPERTIES = {
  'USDA Organic': '/images/usda-organic.png',
  'Made in the USA': '/images/made-in-the-usa.png',
  'Peta Badge': '/images/vegan-cruelty-free.png',
  'Leaping Bunny Badge': '/images/cruelty-free.png',
  'Cosmos Organic': '/images/cosmos-organic.png',
  'B Corp Certification': '/images/Bcertified.svg',
  'EWG Verification': '/images/EWGverified.svg',
  'OEXO-Tex Standard 100 Certification': '/images/oeko-tex.svg'
};

const Awards = ({ product, awards }) => {
  if (!awards || awards.length === 0) return null;

  const parsedAwards = awards.filter(
    (property) => AWARD_PROPERTIES[property.value]
  );

  return (parsedAwards && parsedAwards.length > 0) ? (
    <ProductPropertyTab title="Awards" product={product}>
      <Typography element="div" like="dec-4">
        {
          parsedAwards.map((item) => (
            <Icon
              key={item.id}
              src={`${process.env.NEXT_PUBLIC_ASSET_HOST}${AWARD_PROPERTIES[item.value]}`}
              alt={item.value}
            />
          ))
        }
      </Typography>
    </ProductPropertyTab>
  ) : null;
};

Awards.defaultProps = {
  awards: []
};

Awards.propTypes = {
  product: PropTypes.object.isRequired,
  awards: PropTypes.array
};

export default Awards;
